import { AppConfig } from './types';

let current: AppConfig | null = null;

function deepFreeze(value: unknown): void {
  if (value === null || typeof value !== 'object') return;
  if (Object.isFrozen(value)) return;
  Object.freeze(value);
  const children = Array.isArray(value) ? value : Object.values(value);
  for (const child of children) deepFreeze(child);
}

export function setConfig(cfg: AppConfig): void {
  deepFreeze(cfg);
  current = cfg;
}

export function getConfig(): AppConfig {
  if (current === null) {
    throw new Error(
      'getConfig() called before the tenant config was loaded. Read config inside components/effects, never at module scope.'
    );
  }
  return current;
}

export function isConfigLoaded(): boolean {
  return current !== null;
}
